import { render, staticRenderFns } from "./configurationRiders.vue?vue&type=template&id=5dcd8f1b&scoped=true"
import script from "./configurationRiders.vue?vue&type=script&lang=js"
export * from "./configurationRiders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcd8f1b",
  null
  
)

export default component.exports